import { createClient } from "@supabase/supabase-js";

import type { Database } from "../types/database/database";

const supabaseUrl: string = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey: string = import.meta.env.VITE_SUPABASE_ANON_KEY;

const options = {
	auth: {
		localStorage: true,
		autoRefreshToken: true,
		persistSession: true,
		detectSessionInUrl: true,
	},

	realtime: {
		params: {
			eventsPerSecond: 10,
		},
	},
	timeout: 60000, // Set timeout to 60 seconds (adjust as needed)
};

export const supabaseClient = createClient<Database>(
	supabaseUrl,
	supabaseKey,
	options,
);

// Function to get the appropriate Supabase storage URL based on environment
export function getSupabaseStorageUrl(): string {
	const baseUrl = import.meta.env.VITE_SUPABASE_URL;
	if (!baseUrl) {
		console.error("VITE_SUPABASE_URL is not defined in environment variables.");
		return ""; // Return empty string or throw an error
	}
	// Ensure the URL ends with a trailing slash
	const url = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
	return `${url}storage/v1/object/public/`;
}
